import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Logo from '../../../../assets/logo.png'
import { menuItems } from '../../config'
import MenuItem from '../MenuItem'
import './index.scss'
import { useTranslation } from 'react-i18next'
import i18n from '../../../../services/language.service'
import { Collapse } from '@mui/material'
import TranslateWrapper from './components/TranslateWrapper'

export const SideBar = ({
  open,
  setOpen,
  isMobile,
  setLogoutModal
}: {
  open: boolean,
  setOpen: any,
  isMobile: boolean,
  setLogoutModal: () => void
}) => {
  const location = useLocation()
  const { t } = useTranslation()

  return (
    <div className='sidebar-wrapper'>
      <div className='sidebar-header'>
        {isMobile && (
          <button className='toggler-icon' onClick={() => setOpen(!open)} aria-label={String(t('NAVBAR.TOGGLE_SIDEBAR'))}>
            <div />
            <div />
            <div />
          </button>
        )}
        <Link className='logo' to='/' role='link'>
          <img src={Logo} alt='logo' role='img'/>
        </Link>
        {isMobile && (
          <TranslateWrapper />
        )}
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit role='navigation'>
        <div className='menu-wrapper'>
          {menuItems?.map((menuItem) => {
            const isActive = menuItem.path === location.pathname
              || menuItem.subpath.some((p) => p === location.pathname)
              || menuItem.submenu.some((s) => s.path === location.pathname || location.pathname.startsWith(s.path + '/'))
            const name = `NAVBAR.${menuItem.name}`
            return (
              <div key={menuItem.name}>
                <MenuItem
                  name={t(name)}
                  path={menuItem.path}
                  Icon={menuItem.svg}
                  active={isActive}
                  submenu={menuItem.submenu}
                  onClick={menuItem.name === 'LOG_OUT' ? () => {
                    setLogoutModal()
                    isMobile && setOpen(false)
                  } : null}
                />
              </div>
            )
          })}
        </div>
      </Collapse>
      {!isMobile && (
        <TranslateWrapper />
      )}
    </div>
  )
}
